import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios"; // or your configured api instance
import { server } from "../../server";

// Async thunk to fetch colors
export const fetchColors = createAsyncThunk(
  "color/fetchColors",
  async (family, { rejectWithValue }) => {
    try {
      const params = family ? { family } : {};
      const response = await axios.get(`${server}/color/get-all`, { params });
      return response.data.colors;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch colors",
      );
    }
  },
);

export const fetchFamilies = createAsyncThunk(
  "color/fetchFamilies",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${server}/color/families`);
      return response.data.families;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch families",
      );
    }
  },
);

const colorSlice = createSlice({
  name: "color",
  initialState: {
    colors: [],
    families: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearColorError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchColors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchColors.fulfilled, (state, action) => {
        state.loading = false;
        state.colors = action.payload;
      })
      .addCase(fetchColors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchFamilies.fulfilled, (state, action) => {
        state.families = action.payload;
      });
  },
});

export const { clearColorError } = colorSlice.actions;
export default colorSlice.reducer;
